// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/style.scss
// module id = 461
// module chunks = 1